import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

// send tabs in this interface type
// tabs: [{
//   label: string;
//   content: React.ReactNode;
// }]

const MuiTabs = ({ tabs }) => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="custom tabs"
        variant="fullWidth"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box sx={{ p: 3 }}>
        {tabs[selectedTab].content}
      </Box>
    </Box>
  );
};

export default MuiTabs;
